const templateUrl = require('./address-form.html');

module.exports = {
  controller: require('./address-form.controller'),
  templateUrl: templateUrl,
  bindings: {
    model: '=ngModel',
    requiredFields: '<ogRequiredFields',
    disabledFields: '<ogDisabledFields',
    disabled: '<ogDisabled'
  },
  require: {
    form: '^form'
  }
};
